import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {PagesService} from "@app/_services/pages.service";
import { combineLatest } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pages-menu',
  templateUrl: 'pages-menu.component.html',
  styleUrls: ['pages-menu.component.scss']
})
export class PagesMenuComponent implements OnInit {
  @Input() level = 0;
  @Input() items:any;
  private subscription: Subscription;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef<HTMLElement>,
    private pagesService: PagesService,
    
    ) {
  }

  get rootPage(){
    
    if(this.level == 0&&this.pagesService.rootPages){
      let rootPage = this.pagesService.rootPages.data[0];
      return {
        id: rootPage.id,
        name: rootPage.name,
        link: rootPage.link,
        type: rootPage.type,
      }
    }
  }

  ngOnInit() {
    
    this.renderer.listen('window', 'click',(event)=>{
      if(!this.elementRef.nativeElement.contains(event.target)){
        this.pagesService.menuSelectedLink = null
      }
    })
    if(!this.items){
      this.subscription = combineLatest([
        this.pagesService.currentPageSubject,
        this.pagesService.rootPagesSubject
      ]).subscribe(
        resp=>{    
          let [currentPage, rootPages] = resp     
          if(currentPage){
            let menuTree = currentPage.parents.data.reduceRight(
              (menuTree,item)=>{
                let fothersSonID = item.children.data.findIndex(
                  child => child.id == menuTree.id
                )                
                item.children.data[fothersSonID] = JSON.parse(JSON.stringify(menuTree))
                return item
              }, currentPage);
            this.items = menuTree.children.data;
          }else{
            if(rootPages){
              this.items = rootPages.data.find( 
                page => page.slug == this.pagesService.rootPage.slug
              )?.children.data
            }
          }
        }     
      )
    }
  }

  ngOnDestroy(){
    this.subscription?.unsubscribe()
  }

}